import { useCurrentInsightPage } from "@radarly/core/insight-pages/context";
import { InsightPage } from "./model";

export function isDraftInsightPage(page: InsightPage) {
  return !page || !page.id || page.id.length === 0;
}

export function isGlobalInsightPage(page: InsightPage) {
  if (page) {
    return page.dashboardId === null;
  }
  // if there is no page, that means we're creating a new one
  // ergo, we check the url to check whether we are in a global or local context
  return !window.location.hash.includes("/dashboard/");
}

export function useIsCurrentInsightPageGlobal() {
  const currentInsightPage = useCurrentInsightPage();
  return isGlobalInsightPage(currentInsightPage);
}

export function useIsInsightPage() {
  const currentInsightPage = useCurrentInsightPage();
  return !!currentInsightPage;
}
